
import vuescroll from 'vuescroll';

export default {
  name: 'BbScroll',
  predefinedBarOptions: {
    keepShow: true,
    background: '#6A6765',
    size: '3px',
    specifyBorderRadius: '4px',
  },
  predefinedRailOptions: {
    size: '3px',
  },
  props: {
    vuescroll: {
      type: Object,
      default: () => ({}),
    },
    scrollPanel: {
      type: Object,
      default: () => ({}),
    },
    rail: {
      type: Object,
      default: () => ({}),
    },
    bar: {
      type: Object,
      default: () => ({}),
    },
    reference: {
      type: String,
      default: '',
    },
  },
  components: {
    vuescroll,
  },
  methods: {},
  computed: {
    optionsSetup() {
      const mergedBarOptions = {
        ...this.$options.predefinedBarOptions,
        ...this.bar,
      };
      const mergedRailOptions = {
        ...this.$options.predefinedRailOptions,
        ...this.rail,
      };
      return {
        vuescroll: this.vuescroll,
        scrollPanel: this.scrollPanel,
        rail: mergedRailOptions,
        bar: mergedBarOptions,
      };
    },
  },
};
